import { charMax, requiredInput, requiredSelect } from "@/rules";
export const rules = {
    planName: [requiredInput(), charMax(20)],
    companyId: [requiredSelect()],
    maintenanceTime: [requiredSelect()],
    carNums: [requiredSelect()],
};
